import {
  Identifiable,
  ProjectStrategicAxis,
  StrategicAxis,
  Project,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    projectStrategicAxeses: Identifiable<ProjectStrategicAxis>[];
  };
};

function getProjectStrategicAxes(httpClient: HttpClient) {
  return (project: Identifiable<Project>) =>
    new Promise<Identifiable<ProjectStrategicAxis>[]>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Response>({
          endpoint: `/projects/${project.uuid}/projectStrategicAxes`,
          method: HttpMethods.GET,
        })
        .then(({ _embedded }) =>
          _embedded ? _embedded.projectStrategicAxeses : [],
        )
        .then(async (projectStrategicAxes) => ({
          projectStrategicAxes,
          strategicAxes: await Promise.all(
            projectStrategicAxes.map((projectStrategicAxis) =>
              httpClient
                .sendHttpRequest<Identifiable<StrategicAxis>>({
                  endpoint: `/projectStrategicAxeses/${projectStrategicAxis.uuid}/strategicAxes`,
                  method: HttpMethods.GET,
                })
                .then(({ uuid, weight }) => ({
                  weight,
                  strategicAxisUuid: uuid,
                  projectStrategicAxisUuid: projectStrategicAxis.uuid,
                })),
            ),
          ),
        }))
        .then(({ projectStrategicAxes, strategicAxes }) =>
          projectStrategicAxes.map((projectStrategicAxis) => ({
            ...projectStrategicAxis,
            strategicAxisId: strategicAxes.find(
              ({ projectStrategicAxisUuid }) =>
                projectStrategicAxisUuid === projectStrategicAxis.uuid,
            )?.strategicAxisUuid as string,
            weight: strategicAxes.find(
              ({ projectStrategicAxisUuid }) =>
                projectStrategicAxisUuid === projectStrategicAxis.uuid,
            )?.weight as number,
          })),
        )
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { getProjectStrategicAxes };
